import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import API from "../../api";

export default function OrderConfirmation() {
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);

    const session_id = new URLSearchParams(useLocation().search).get("session_id");

    useEffect(() => {
    const fetchOrder = async () => {
        try {
        const res = await API.get(`/stripe/session/${session_id}`);
        setOrder(res.data);
        } catch (error) {
        console.error("Error fetching session:", error);
        } finally {
        setLoading(false);
        }
    };

    if (session_id) fetchOrder();
    }, [session_id]);

    return (
    <div className="relative min-h-screen bg-[#0D1117] flex items-start justify-center px-4 sm:px-6 lg:px-8 pt-28">

        {/* Background */}
        <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
        <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
        </div>

        <div className="relative z-10 w-full max-w-md bg-[#161B22] rounded-2xl shadow-[0_0_20px_#3B82F6]/20 p-8">
        {loading ? (
            <p className="text-center text-[#8B949E]">Loading your order...</p>
        ) : (
            <>
            <h2 className="text-3xl font-bold text-center text-[#E6EDF3] mb-2">
                Payment Successful ✅
            </h2>

            <p className="text-center text-[#8B949E] mb-6">
                Thank you for your purchase!
            </p>

            <div className="bg-[#0D1117] border border-[#30363D] rounded-xl p-4">
                <div className="flex justify-between text-sm mb-2">
                <span className="text-[#8B949E]">Name:</span>
                <span className="font-medium text-white">
                    {order?.customerName || "Unknown"}
                </span>
                </div>

                <div className="flex justify-between text-sm mb-2">
                <span className="text-[#8B949E]">Amount:</span>
                <span className="font-semibold text-white">{order?.amount} €</span>
                </div>

                <div className="flex justify-between text-sm mb-2">
                <span className="text-[#8B949E]">Tokens received:</span>
                <span className="font-semibold text-[#3B82F6]">
                    {order?.tokenAmount}
                </span>
                </div>

                <div className="flex justify-between text-xs mt-2">
                <span className="text-[#6E7681]">Date:</span>
                <span className="text-[#6E7681]">
                    {new Date(order?.date).toLocaleDateString()}
                </span>
                </div>
            </div>

            <Link
                to="/dashboard/hook"
                className="block w-full py-3 mt-6 rounded-xl bg-[#1F6FEB] hover:bg-[#388BFD] text-white text-center font-semibold transition shadow-[0_0_10px_#1F6FEB]/30"
            >
                Use My Tokens 🚀
            </Link>
            </>
        )}
        </div>
    </div>
    );
}
